import * as React from 'react';
import { useSelector } from 'react-redux';
import { TButtonSize } from '@cian/ui-kit/button/types';

import { trackSendMessageClick } from './tracking';
import { MessageButton } from '../../components/MessageButton';
import { useBuilderChat } from '../../hooks/useBuilderChat';
import { getGaLabel } from '../../selectors/analytics';
import { getUser } from '../../selectors/user';
import { getFirstBuilder } from '../../selectors/newbuilding';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';

interface IBuilderChatButtonContainerProps {
  buttonSize?: TButtonSize;
  icon?: JSX.Element;
  withOnboarding?: boolean;
}

export const BuilderChatButtonContainer: React.FC<IBuilderChatButtonContainerProps> = ({
  buttonSize = 'M',
  icon,
  withOnboarding = false,
}) => {
  const user = useSelector(getUser);
  const builder = useSelector(getFirstBuilder);
  const gaLabel = useSelector(getGaLabel);
  const isChatEnabled = useSelector(getBuilderChatEnabled);

  const { openChat } = useBuilderChat();

  const handleClick = React.useCallback(() => {
    trackSendMessageClick({ label: gaLabel });
    openChat();
  }, [openChat, gaLabel]);

  if (!builder) {
    return null;
  }

  const isOwnNewbuilding = builder.realtyUserId === user.userId;

  if (!isChatEnabled || isOwnNewbuilding) {
    return null;
  }

  const messageButton = (
    <MessageButton onClick={handleClick} buttonSize={buttonSize} icon={icon}>
      Написать застройщику
    </MessageButton>
  );

  if (withOnboarding) {
    return (
      <ChatOnboardingContainer type="builder" placement="left-start">
        {messageButton}
      </ChatOnboardingContainer>
    );
  }

  return messageButton;
};
